import { t } from 'i18next';
import { useCallback, useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { sendRequest, serviceList } from 'src/utils';

const useHookWarning = () => {
    const getWarningRef = useRef(false);
    const getWarningStopRef = useRef(false);
    const [listWarning, setListWarning] = useState([]);
    const [totalUnReadWarning, setTotalUnReadWarning] = useState(0);
    const [totalNotiWarning, setTotalNotiWarning] = useState(0);
    const [loading, setLoading] = useState(false);
    const lastIDWarning = useRef(0);
    const [needGetDataWarningNext, setNeedGetDataWarningNext] = useState(false);
    const [getFlagsWarning, setGetFlagsWarning] = useState(false);

    const handleScrollToBottom = useCallback(() => {
        if (!loading && !needGetDataWarningNext) {
            setLoading(true);
            setNeedGetDataWarningNext(true);
        }
    }, [loading, needGetDataWarningNext]);

    useEffect(() => {
        if (needGetDataWarningNext && lastIDWarning.current) {
            getDataWarningNext();
            setNeedGetDataWarningNext(false);
            setLoading(false);
        }
    }, [needGetDataWarningNext]);

    const getDataWarning = useCallback(() => {
        if (getWarningRef.current || getWarningStopRef.current) {
            return;
        }
        getWarningRef.current = true;
        setGetFlagsWarning(true);
        const Inval = [9999999999999999999];
        sendRequest(serviceList.getListWarning, Inval, getDataWarningResult, true, timeOutFunctGetWarning, 40000);
    }, [getWarningRef, getWarningStopRef, getFlagsWarning]);

    const getDataWarningResult = (reqInfoMap, message) => {
        getWarningRef.current = false;
        setGetFlagsWarning(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            // console.log("success getData Warning", message.proc_data)
            const newNottiWarnig = (message.proc_data.rows[0]?.o_1 || []).filter((row) => row.device_nm);
            if (newNottiWarnig.at(-1)?.notify_id !== lastIDWarning.current) {
                setListWarning(newNottiWarnig);
                setTotalUnReadWarning(message.proc_data.total_not_read);
                setTotalNotiWarning(message.proc_data.total_not_read + message.proc_data.total_read);
                lastIDWarning.current = message.proc_data.rows[0].o_1.at(-1)?.notify_id;
                getWarningStopRef.current = false;
            } else {
                getWarningStopRef.current = true;
            }
            // console.log("lastID Warning", lastIDWarning.current)
        }
    };

    const getDataWarningNext = useCallback(() => {
        if (getWarningRef.current || getWarningStopRef.current || getFlagsWarning) {
            return;
        }
        getWarningRef.current = true;
        setGetFlagsWarning(true);
        const Inval = [lastIDWarning.current];
        sendRequest(serviceList.getListWarning, Inval, getDataWarningNextResult, true, timeOutFunctGetWarning, 40000);
    }, [lastIDWarning.current]);

    const getDataWarningNextResult = (reqInfoMap, message) => {
        getWarningRef.current = false;
        setGetFlagsWarning(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            const newNottiWarnig = (message.proc_data.rows[0]?.o_1 || []).filter((row) => row.device_nm);
            if (newNottiWarnig.at(-1)?.notify_id !== lastIDWarning.current) {
                setListWarning((prev) => [...prev, ...newNottiWarnig]);
                setTotalUnReadWarning(message.proc_data.total_not_read);
                setTotalNotiWarning(message.proc_data.total_not_read + message.proc_data.total_read);
                if (message.proc_data.rows[0].o_1?.length > 0) {
                    lastIDWarning.current = message.proc_data.rows[0].o_1.at(-1)?.notify_id;
                    getWarningStopRef.current = false;
                } else {
                    getWarningStopRef.current = true;
                }
            } else {
                getWarningStopRef.current = true;
            }
        }
    };

    const timeOutFunctGetWarning = (reqInfo) => {
        getWarningRef.current = false;
        setGetFlagsWarning(false);
        toast.error(t('error.time_out'));
        // console.log("timeOut Warning");
    };
    return {
        handleScrollToBottomWarning: handleScrollToBottom,
        loadingWarning: loading,
        setLoadingWarning: setLoading,
        lastIDWarning,
        needGetDataWarningNext,
        setNeedGetDataWarningNext,
        getFlagsWarning,
        setGetFlagsWarning,
        getDataWarning,
        getWarningRef,
        getWarningStopRef,
        listWarning,
        setListWarning,
        totalUnReadWarning,
        setTotalUnReadWarning,
        totalNotiWarning,
        setTotalNotiWarning,
    };
};

export default useHookWarning;
